import angular from 'angular';
import uiRouter from 'angular-ui-router';
import cardComponent from './card.component';
import cardListComponent from './card-list.component';
import cardDetailComponent from './card-detail.component';
import cardService from './card.service';

let cardModule = angular.module('card', [
  uiRouter
])

.service('Card', cardService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/card');

  $stateProvider
    .state('card', {
      component: 'card'
    })
    .state('card.list', {
      url: '/card',
      component: 'cardList'
    })
    .state('card.create', {
      url: '/card/new',
      component: 'cardDetail',
      params: {
      	id: ""
      }
    })
    .state('card.edit', {
      url: '/card/:id/edit',
      component: 'cardDetail',
      params: {
        id: ""
      }
    });
})

.component('card', cardComponent)
.component('cardList', cardListComponent)
.component('cardDetail', cardDetailComponent)

.name;

export default cardModule;



// WEBPACK FOOTER //
// ./client/app/components/card/card.js